import React from 'react';
export function Footer() {
  return <footer id="contact" className="px-6 py-16 bg-white border-t border-zinc-200" data-id="element-188">
      <div className="max-w-7xl mx-auto" data-id="element-189">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-190">
          <div className="md:col-span-2" data-id="element-191">
            <h3 className="text-2xl font-serif mb-4" style={{
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-192">
              NAD+
            </h3>
            <p className="text-zinc-600 leading-relaxed max-w-md" data-id="element-193">
              Redefining cellular wellness through precision science and
              uncompromising quality.
            </p>
          </div>
          <div data-id="element-194">
            <h4 className="text-sm tracking-[0.2em] uppercase mb-4 text-zinc-900" data-id="element-195">
              Explore
            </h4>
            <ul className="space-y-3 text-zinc-600" data-id="element-196">
              <li data-id="element-197">
                <a href="#science" className="hover:text-zinc-900 transition-colors" data-id="element-198">
                  Science
                </a>
              </li>
              <li data-id="element-199">
                <a href="#product" className="hover:text-zinc-900 transition-colors" data-id="element-200">
                  Product
                </a>
              </li>
              <li data-id="element-201">
                <a href="#" className="hover:text-zinc-900 transition-colors" data-id="element-202">
                  Research
                </a>
              </li>
              <li data-id="element-203">
                <a href="#" className="hover:text-zinc-900 transition-colors" data-id="element-204">
                  About
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-205">
            <h4 className="text-sm tracking-[0.2em] uppercase mb-4 text-zinc-900" data-id="element-206">
              Connect
            </h4>
            <ul className="space-y-3 text-zinc-600" data-id="element-207">
              <li data-id="element-208">
                <a href="#" className="hover:text-zinc-900 transition-colors" data-id="element-209">
                  Instagram
                </a>
              </li>
              <li data-id="element-210">
                <a href="#" className="hover:text-zinc-900 transition-colors" data-id="element-211">
                  Contact
                </a>
              </li>
              <li data-id="element-212">
                <a href="#" className="hover:text-zinc-900 transition-colors" data-id="element-213">
                  Press
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-zinc-200 flex flex-col md:flex-row justify-between items-center text-sm text-zinc-500" data-id="element-214">
          <p data-id="element-215">&copy; 2024 NAD+. All rights reserved.</p>
          <div className="flex space-x-8 mt-4 md:mt-0" data-id="element-216">
            <a href="#" className="hover:text-zinc-900 transition-colors" data-id="element-217">
              Privacy
            </a>
            <a href="#" className="hover:text-zinc-900 transition-colors" data-id="element-218">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>;
}